import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'


import axios from 'axios'
import router from './router'
import store from './store'
import App from './App.vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueGeolocation from 'vue-browser-geolocation';
import VueHtml2Canvas from 'vue-html2canvas';

//
import '@/libs/sweet-alerts'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueGeolocation);
Vue.use(VueHtml2Canvas);
Vue.use(VueMoment, {
  moment,
})

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.component('apexchart', VueApexCharts)


Vue.config.productionTip = false

//moment

Vue.prototype.moment = moment
moment.locale('id')
// axios Configuration
Vue.prototype.$http = axios
const token = localStorage.getItem('token')
const token_type = localStorage.getItem('token_type')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token_type + ' ' + token
}

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['X-Frame-Options'] = 'ALLOW-FROM ' + process.env.VUE_APP_API_URL
axios.defaults.withCredentials = true

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
